import { equals } from "ramda";

const getNode = (n) => n.getNode();

// (DataSourceNode, DOMNode, String) -> Boolean
const isMatch = (dataSource, node, path) =>
    dataSource
        .selectNodes(path)
        .map(getNode)
        .some(equals(node));

// (CharacterLimitMap, DataSourceCollection, DOMNode, String) -> CharacterLimit | null
export default (characterLimitMap, dataSources, node, ctrlId) => {
    if (!node) {
        return null;
    }

    const byCtrlId = characterLimitMap.byCtrlId[ctrlId];

    if (byCtrlId) { return byCtrlId; }

    const byFieldName = characterLimitMap.byFieldName[node.localName];

    return byFieldName
        ? byFieldName.find(
            ({ xpath, dsName }) => isMatch(dataSources.getDom(dsName), node, xpath)
        )
        : null;
};